import React from 'react';
import { MyProperties } from '../../components/MyProperties'

export const MyPropertiesPage = () => {
  return <MyProperties/>
}
